function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.8687 17.258H12.3993L12.4191 17.727L12.4263 17.8993C12.5003 19.6516 11.0996 21.1125 9.34579 21.1125C7.64294 21.1125 6.2625 19.7321 6.2625 18.0292V5.75C6.2625 4.84723 5.88867 4.03178 5.28736 3.45H16.25C18.2106 3.45 19.8 5.03939 19.8 7V17.258H12.8687Z",
  stroke: "#00AAFF",
  strokeWidth: 0.9
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.85259 3.4H3.78599C2.46824 3.4 1.4 4.46824 1.4 5.78599V7.4125H6.1V5.64741C6.1 5.13709 5.92632 4.64196 5.60752 4.24346C5.18103 3.71034 4.53532 3.4 3.85259 3.4Z",
  stroke: "#00AAFF",
  strokeWidth: 0.8
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4 18.125C12.4 19.3611 11.8156 20.4606 10.908 21.1625H19C20.9882 21.1625 22.6 19.5507 22.6 17.5625V17.4H12.4V18.125Z",
  stroke: "#00AAFF",
  strokeWidth: 0.8
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.284 9.2711C12.284 9.2711 14.0518 10.155 14.0518 8.97646C14.0518 7.91411 12.284 8.43498 12.284 7.50325C12.284 6.61932 13.4625 6.61933 14.0518 7.20861",
  stroke: "#00AAFF",
  strokeWidth: 0.6,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1646 9.91821L13.1646 6.38251",
  stroke: "#00AAFF",
  strokeWidth: 0.6,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0899 8.19495C16.0899 9.79378 14.7938 11.0899 13.1949 11.0899C11.5961 11.0899 10.3 9.79378 10.3 8.19495C10.3 6.59611 11.5961 5.3 13.1949 5.3C14.7938 5.3 16.0899 6.59611 16.0899 8.19495Z",
  stroke: "#00AAFF",
  strokeWidth: 0.6
});
var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 9.4,
  y1: 13.6,
  x2: 17.6,
  y2: 13.6,
  stroke: "#00AAFF",
  strokeWidth: 0.8,
  strokeLinecap: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("line", {
  x1: 9.4,
  y1: 15.6,
  x2: 17.6,
  y2: 15.6,
  stroke: "#00AAFF",
  strokeWidth: 0.8,
  strokeLinecap: "round"
});
const SvgBillFacture = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBillFacture, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bill-facture.2c252b09.svg";
export { ForwardRef as ReactComponent };